import {
  addDoc,
  collection,
  getDocs,
  orderBy,
  query,
  Timestamp,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useCollectionQuery } from "../../../hooks/useCollectionQuery";
import { db } from "../../../shared/firebase";
import CommentUserData from "./CommentUserData";

const Reply = ({ commendId }) => {
  const [commentLimit, setCommentLimit] = useState(5);

  const {
    data: commentData,
    isLoading,
    isError,
  } = useCollectionQuery(
    commendId,
    query(collection(db, `replyTo-${commendId}`), orderBy("createdAt", "desc"))
  );

  // Auto Reply on Admin Comment
  useEffect(() => {
    const dummyUserID1 = "jCSwJtPNknQFLT4sNytZ6g8xudi2";
    getDocs(collection(db, "replyTo-admin")).then((docSnapshot) => {
      if (
        !docSnapshot.docs.some((doc) => doc.data()?.user.uid === dummyUserID1)
      ) {
        const dummyUserID2 = "mtDrEP3x51UBgHzkzeJFtGYv0tX2";
        const dummyUserID3 = "RO6eEaJPPiORTF9PWS0Yh7HswLn2";
        const sampleReactions = {};
        sampleReactions[dummyUserID2] = "like";
        sampleReactions[dummyUserID3] = "love";

        addDoc(collection(db, "replyTo-admin"), {
          user: {
            displayName: "Sumit Sharma",
            email: "shwetKhatri4301@gmail.com",
            emailVerified: true,
            photoURL: "https://cutt.ly/M82icCC",
            uid: dummyUserID1,
          },
          value:
            "Yes, I also found myself laughing and crying along with the characters, which is always a sign of a great movie in my book.",
          reactions: sampleReactions,
          createdAt: Timestamp.fromDate(new Date("March 28, 2023 22:10:00")),
          isEdited: false,
        });
      }
    });
  }, []);

  return (
    <>
      {commentData && commentData.size > 0 && (
        <div className="mt-5">
          <CommentUserData
            role="reply"
            isLoading={isLoading}
            isError={isError}
            sortType="latest"
            commentData={commentData}
            commentLimit={commentLimit}
            media_type="replyTo"
            id={commendId}
          />
        </div>
      )}
      {commentData && commentData.size > commentLimit && (
        <button
          className="font-medium mt-3"
          onClick={() => setCommentLimit((prev) => prev + 5)}
        >
          Load more replies ({commentLimit}/{commentData.size})
        </button>
      )}
    </>
  );
};

export default Reply;
